export default __webpack_public_path__ + "static/media/loading-roll.375b78e7.svg";